import OffersComponent from '../componetns/menu/offers/OffersComponent';
import './Page.css';
import CardVeryBig from "../componetns/card/CardVeryBig";
import React from "react";

function Offers() {
    return (
        <div className="main_work_field">
            <CardVeryBig/>
            <OffersComponent/>
        </div>
    );
}

export default Offers;